<template>
  <div class="flex justify-center w-full h-full" id="app">
    <SvgMap
      :view-box="viewBox"
      :loading="loading"
      :map-data="mapData"
      :sensor-data="sensorData"
      :dashboard-page="false"
      @fetchHumid="fetchHumid"
      @fetchTemp="fetchTemp"
      :active-index="activeIndex"
    />
    <!--           :height-map="'350px'" -->
    <!-- :width-map="'400px'" -->
  </div>
</template>

<script>
import SvgMap from '@/components/Portal/SvgMap'

export default {
  name: 'App',
  components: {
    SvgMap
  },
  data() {
    return {
      viewBox: '',
      activeIndex: '',
      loading: false,
      mapData: [],
      sensorData: [],
      svgpanzoom: null,
      // dataCage: [],
      index: 0
    }
  },
  mounted() {
    this.fetchMap()
  },
  methods: {
    fetchHumid() {
      this.fetchSensor('RACKHUMID')
      console.log('hey')
    },
    fetchTemp() {
      this.fetchSensor('RACKTEMP')
    },
    async fetchSensor(device) {
      try {
        const res = await this.$axios.get(
          `Dashboard/GetDashboardScreenData?screen=${device}`
        )
        this.sensorData = res.data[0].ListOfSensor
        console.log(this.sensorData)
      } catch (e) {
        console.log(e)
      }
    },
    async fetchMap() {
      try {
        this.loading = true
        const res = await this.$axios.get(
          `MapSketch/GetAllChildrenAssetDCO?dcoId=${this.$route.params.id}`
        )
        this.mapData = res.data
        this.loading = false
        let cage = res.data.find((x) => x.Type == 'server-room')
        this.viewBox = `0, 0, ${cage.CanvasWidth}, ${cage.CanvasHeight}`
        console.log(this.viewBox)
      } catch (e) {
        this.loading = false
        console.log(e)
      }
    },
    zoomButton() {
      this.svgpanzoom.zoomIn()
    },
    zoomOutButton() {
      this.svgpanzoom.zoomOut()
    },
    resetButton() {
      this.svgpanzoom.resetZoom()
    },
    registerSvgPanZoom(svgpanzoom) {
      this.svgpanzoom = svgpanzoom
    },
    center() {
      if (!this.svgpanzoom) return

      this.svgpanzoom.center()
    }
  }
}
</script>

<style scoped>
.linkActive {
  fill: #4e8cb1;
  stroke: #b3b3b3;
}

#floorContainer {
  stroke: gray;
}

.floorItemPerforatedTile {
  stroke: grey;
  stroke-width: 10;
  fill: #fafafa;
}

/* .inside-rack polygon {
  fill: #1888b6;
} */

/* g.floorItem:not(.pdu):not(.door) polygon {
  fill: #ffffff;
  opacity: 0.1;
} */

g.floorItemFrontMaker {
  fill: #4e8cb14f;
}

g.floorItem:not(.pdu):not(.door) polygon {
  fill: #4e8db1;
}

g.floorItem:not(.pdu):not(.door) polygon:hover {
  fill: #a2bbc9;
}
g.floorItem:not(.pdu):not(.door) polygon.linkActive {
  fill: #96d0f1;
}

svg {
  cursor: pointer;
}

.wallMeshBorder {
  stroke-dasharray: 150, 50;
  stroke: #b3b3b3;
}
.center-svg {
  display: f;
}
.floorItemPerforatedTile {
  stroke: grey;
  stroke-width: 30;
  fill: #fafafa;
}
</style>
